import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

// import Colors from '../../resource/ResourceColors.jsx';
import TrackAction from './TrackAction.jsx';

const NotesBar = styled.div`
    position:relative;
    top: 0.25rem;
    right: 0;
    left: 0;
    height: 100%;
`;

export class TrackNoteEvents extends Component {

    static propTypes = {
        note_events: PropTypes.array.isRequired,
        track_index: PropTypes.number.isRequired,
        zoom_factor: PropTypes.number.isRequired,
        note_height_rem: PropTypes.number.isRequired,
    }

    state = {
        zoom_factor: this.props.zoom_factor,
        content: '',
        all_action_refs: []
    };

    componentDidMount() {
        const all_action_refs = [];
        const content = this.props.note_events.map((event, event_index) => {
            return event.actions.map((action, action_index) => {
                const height_rem = this.props.note_height_rem / event.actions.length;
                const key = 'event_' + event_index + '_track_' + this.props.track_index + '_action_' + action_index;
                action.ref = React.createRef();
                all_action_refs.push(action.ref);
                return <TrackAction
                    ref={action.ref}
                    key={key}
                    action={action}
                    event={event}
                    hsl={action.hsl}
                    top_rem={height_rem * action_index}
                    height_rem={height_rem}
                />
            });
        });
        this.setState({
            content: content,
            all_action_refs: all_action_refs
        })
    }

    set_zoom_factor(zoom_factor) {
        console.log('TrackNoteEvents zoom_factor', zoom_factor)
        this.state.all_action_refs.forEach(action_ref => {
            if (action_ref.current) {
                action_ref.current.set_zoom(zoom_factor)
            }
        })
        this.setState({zoom_factor: zoom_factor})
    }

    render() {
        return <NotesBar>
            {this.state.content}
        </NotesBar>
    }
}

export default TrackNoteEvents;

